import { combineReducers } from "redux";
import AccountTypeR from "../redusers/AccountTypeReduser";
import authReducer from "../redusers/AuthReducer";
import FileR from "../redusers/FileReduser";
import MainAccountR from "../redusers/MainAccountReduser";
import FileDetailsR from "../redusers/FileDetailsReduser";
import SupAccountR from "../redusers/SupAccountReduser";
import SubuserR from "../redusers/AddSubuserReduser";
import ManageAdminR from "../redusers/ManageAdminReduser";
import UserSubscriptionR from "../redusers/UserSubscriptionReduser";
import ContactR from "../redusers/ContactReduser";
import DepartmentR from "./DepartmentReduser";
import JopTitleR from "./JopTitleReduser";
import EmployeeR from "./EmployeeReduser";
import HolidayR from "./HolidayReduser";
import AttendenceR from "./AttendenceReduser";
import AdminRequestR from "./AdminRequestReduser";
import SalaryR from "./SalaryReduser";
import EmployeePageR from "./EmployeePageReduser";
export default combineReducers({
  AccountTypeR,
  authReducer,
  MainAccountR,
  FileR,
  FileDetailsR,
  SupAccountR,
  SubuserR,
  ManageAdminR,
  UserSubscriptionR,
  ContactR,
  DepartmentR,
  JopTitleR,
  EmployeeR,
  HolidayR,
  AttendenceR,
  AdminRequestR,
  SalaryR,
  EmployeePageR
});
